import { useEffect, useCallback } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slice';
import {
  useLazyGetCustomersPermissionsQuery,
  useLazyGetClientsWhitelabelQuery,
  useLazyGetCustomersPaymentTypesQuery,
} from './store/dictionaries/services';
import IndividualCustomers from './routes/individual-customers';
import CorporateCustomers from './routes/corporate-customers';
import NewAppliation from './routes/new-application';
import Customers from './hoc/customers/customers';
import SumSub from './hoc/sumsub/sumsub';
import NotificationCenter from './hoc/notification-center/notification-center';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.CUSTOMERS,
  element: <Customers />,
  children: [
    { ...IndividualCustomers },
    { ...CorporateCustomers },
    { ...NewAppliation },
    {
      path: ROUTES.SUMSUB,
      element: <SumSub />,
    },
    {
      path: ROUTES.CUSTOMERS_NOTIFICATIONS_CENTER,
      element: <NotificationCenter />,
    },
  ],
};

const CustomersRoutes = () => {
  const elements = useRoutes([
    {
      path: '/',
      element: (
        <Outlet
          context={{
            connectionStatus: null,
            sendMessage: null,
          }}
        />
      ),
      children: [{ ...routes }],
    },
  ]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel, paymentTypes } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const [getCustomersPermissions] = useLazyGetCustomersPermissionsQuery();
  const [getClientsWhiteLabel] = useLazyGetClientsWhitelabelQuery();
  const [getCustomersPaymentTypes] = useLazyGetCustomersPaymentTypesQuery();

  const getCustomersPermissionsAction = useCallback(() => {
    getCustomersPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getClientsWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (!paymentTypes) {
      getCustomersPaymentTypes();
    }
  }, [paymentTypes]);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getCustomersPermissionsAction();
    }
  }, [permissions, getCustomersPermissionsAction, dispatch, activePermissions]);

  return elements;
};

export default CustomersRoutes;
